<div class="wn__value-card-inner">
  <h3 class="wn__value-card-title">
    <div class="wn__value-card-title-row">
      @if (tabId() === 'discover') {
        <img
          class="wn__value-card-icon"
          src="icons/discover.svg"
          width="24"
          height="24"
          alt=""
          aria-hidden="true"
        />
      }
      @if (tabId() === 'connect') {
        <img
          class="wn__value-card-icon"
          src="icons/connect.svg"
          width="24"
          height="24"
          alt=""
          aria-hidden="true"
        />
      }
      @if (tabId() === 'reuse') {
        <img
          class="wn__value-card-icon"
          src="icons/reuse.svg"
          width="24"
          height="24"
          alt=""
          aria-hidden="true"
        />
      }
      <span class="wn__value-card-title-accent">{{ accent() }}</span>
    </div>
    <span class="wn__value-card-title-rest">{{ titleRest() }}</span>
  </h3>
  @for (para of body(); track $index) {
    <p class="wn__value-card-para">{{ para }}</p>
  }
</div>
